import { Mail, CheckCircle2, XCircle, Loader2, MailX } from "lucide-react";

const EmailStatusBadge = ({ workOrder, showLabel = true }) => {
  const status = workOrder?.email_status || "";

  // No engineer email set
  if (!workOrder?.engineer_email) {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-semibold bg-[#F4F4F5] text-[#71717A] border border-[#E4E4E7]"
        title="No engineer email"
        data-testid={`email-status-none-${workOrder?.work_order_number || "x"}`}
      >
        <MailX className="w-3 h-3" />
        {showLabel && "No Email"}
      </span>
    );
  }

  if (status === "sent") {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-semibold bg-[#D1FAE5] text-[#059669] border border-[#A7F3D0]"
        title={`Email sent to ${workOrder.email_recipient || workOrder.engineer_email}${workOrder.email_attachments_count ? ` with ${workOrder.email_attachments_count} photo(s)` : ""}`}
        data-testid={`email-status-sent-${workOrder.work_order_number}`}
      >
        <CheckCircle2 className="w-3 h-3" />
        {showLabel && "Sent"}
      </span>
    );
  }

  if (status === "failed") {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-semibold bg-[#FEE2E2] text-[#DC2626] border border-[#FECACA]"
        title={`Email failed: ${workOrder.email_error || "unknown error"}`}
        data-testid={`email-status-failed-${workOrder.work_order_number}`}
      >
        <XCircle className="w-3 h-3" />
        {showLabel && "Failed"}
      </span>
    );
  }

  if (status === "pending") {
    return (
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-semibold bg-[#FEF3C7] text-[#D97706] border border-[#FDE68A]"
        title="Email sending..."
        data-testid={`email-status-pending-${workOrder.work_order_number}`}
      >
        <Loader2 className="w-3 h-3 animate-spin" />
        {showLabel && "Sending"}
      </span>
    );
  }

  // Has email but not sent yet
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] font-semibold bg-[#F4F4F5] text-[#71717A] border border-[#E4E4E7]"
      title="Email not yet sent"
      data-testid={`email-status-notsent-${workOrder.work_order_number}`}
    >
      <Mail className="w-3 h-3" />
      {showLabel && "Not Sent"}
    </span>
  );
};

export default EmailStatusBadge;
